import { AccountWrenchIcon } from './AccountWrenchIcon';

/**
 * author: Michael Irigoyen
 * id C3712CBF-1E1C-4794-95B1-F77380FCEB7C
 * name account-wrench
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-wrench.svg
 * tags
 * - Account / User 
 */
export const AccountServiceIcon = AccountWrenchIcon;
export default AccountServiceIcon